export default function({ $axios, redirect, app, req }) {
  // const locale = ctx.app.store.state.locale
  // $axios.setHeader('Client-Lang', locale)
  // $axios.setHeader('platform', 'web')
  $axios.onRequest(config => {
    const locale = app.store.state.locale
    config.headers.common['Client-Lang'] = locale
    config.headers.common['platform'] = 'web'
    return config
  })

  $axios.onResponse(response => {
    const res = response.data
    if (res.statusCode !== 200) {
      if (res.statusCode === 403) {
        console.log('登录')
      } else {
        return res
      }
    }
    return res
  })

  $axios.onResponseError(err => {
    if (err) {
      app.$sentry.captureException(err)
      return Promise.resolve({
        status: 500,
        err: err.response,
        result: {}
      })
    }
  })

  $axios.onResponseError(error => {
    if (error) {
      return Promise.resolve({
        statusCode: 200,
        message: error,
        result: null
      })
    }
  })

  $axios.onError(error => {
    const code = parseInt(error.response && error.response.status)
    if (code === 400) {
      redirect('/400')
    }
  })
}
